{
  "name": "detailyx-backoffice",
  "version": "1.0.5",
  "packageManager": "pnpm@12.3.4",
  "date": "02/02/2026",
  "scripts": {
    "ng": "node ./node_modules/@angular/cli/bin/ng.js",
    "start": "node scripts/generate-angular-env.mjs .env.local src/environments/environment.generated.ts local && node ./node_modules/@angular/cli/bin/ng.js serve --configuration=local",
    "build": "node scripts/generate-angular-env.mjs .env.local src/environments/environment.generated.ts local && node ./node_modules/@angular/cli/bin/ng.js build --configuration=local",
    "build:local": "node scripts/generate-angular-env.mjs .env.local src/environments/environment.generated.ts local && node ./node_modules/@angular/cli/bin/ng.js build --configuration=local",
    "build:dev": "node scripts/generate-angular-env.mjs .env.dev src/environments/environment.generated.ts dev && node ./node_modules/@angular/cli/bin/ng.js build --configuration=dev",
    "build:prod": "node scripts/generate-angular-env.mjs .env.prod src/environments/environment.generated.ts prod && node ./node_modules/@angular/cli/bin/ng.js build --configuration=prod",
    "watch": "node scripts/generate-angular-env.mjs .env.local src/environments/environment.generated.ts local && node ./node_modules/@angular/cli/bin/ng.js build --watch --configuration=local",
    "test": "node scripts/generate-angular-env.mjs .env.local src/environments/environment.generated.ts local && node ./node_modules/@angular/cli/bin/ng.js test --watch=false"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.1",
    "@angular/common": "^21.0.1",
    "@angular/compiler": "^21.0.1",
    "@angular/core": "^21.0.1",
    "@angular/forms": "^21.0.1",
    "@angular/google-maps": "^21.0.0",
    "@angular/material": "^21.0.0",
    "@angular/platform-browser": "^21.0.1",
    "@angular/platform-browser-dynamic": "^21.0.1",
    "@angular/router": "^21.0.1",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.3",
    "bootstrap-icons": "^1.11.3",
    "chart.js": "^4.3.0",
    "ng2-charts": "^8.0.0",
    "ngx-mask": "^19.0.6",
    "rxjs": "~7.8.1",
    "tslib": "^2.8.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.1",
    "@angular/cli": "^21.0.1",
    "@angular/compiler-cli": "^21.0.1",
    "@angular/localize": "^21.0.1",
    "@types/jasmine": "~5.1.6",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}
